module.exports = require('./isArray')
